import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import commonEn from './locales/en/common.json'
import navEn from './locales/en/nav.json'
import authEn from './locales/en/auth.json'
import residentsEn from './locales/en/residents.json'
import buildingsEn from './locales/en/buildings.json'
import maintenanceEn from './locales/en/maintenance.json'
import financeEn from './locales/en/finance.json'
import accessControlEn from './locales/en/accessControl.json'
import commonAreasEn from './locales/en/commonAreas.json'
import comunicacaoEn from './locales/en/comunicacao.json'
import assembleiasEn from './locales/en/assembleias.json'
import blocksEn from './locales/en/blocks.json'
import unitsEn from './locales/en/units.json'
import rolesEn from './locales/en/roles.json'
import usersEn from './locales/en/users.json'
import condominiumsEn from './locales/en/condominiums.json'
import rentalsEn from './locales/en/rentals.json'
import parkingEn from './locales/en/parking.json'
import settingsEn from './locales/en/settings.json'
import modulesEn from './locales/en/modules.json'
import companyEn from './locales/en/company.json'
import supportEn from './locales/en/support.json'
import dashboardEn from './locales/en/dashboard.json'

import commonPt from './locales/pt/common.json'
import navPt from './locales/pt/nav.json'
import authPt from './locales/pt/auth.json'
import residentsPt from './locales/pt/residents.json'
import buildingsPt from './locales/pt/buildings.json'
import maintenancePt from './locales/pt/maintenance.json'
import financePt from './locales/pt/finance.json'
import accessControlPt from './locales/pt/accessControl.json'
import commonAreasPt from './locales/pt/commonAreas.json'
import comunicacaoPt from './locales/pt/comunicacao.json'
import assembleiasPt from './locales/pt/assembleias.json'
import blocksPt from './locales/pt/blocks.json'
import unitsPt from './locales/pt/units.json'
import rolesPt from './locales/pt/roles.json'
import usersPt from './locales/pt/users.json'
import condominiumsPt from './locales/pt/condominiums.json'
import rentalsPt from './locales/pt/rentals.json'
import parkingPt from './locales/pt/parking.json'
import settingsPt from './locales/pt/settings.json'
import modulesPt from './locales/pt/modules.json'
import companyPt from './locales/pt/company.json'
import supportPt from './locales/pt/support.json'
import dashboardPt from './locales/pt/dashboard.json'

export const defaultNS = 'common'

export const resources = {
  en: {
    common: commonEn,
    nav: navEn,
    auth: authEn,
    residents: residentsEn,
    buildings: buildingsEn,
    maintenance: maintenanceEn,
    finance: financeEn,
    accessControl: accessControlEn,
    commonAreas: commonAreasEn,
    comunicacao: comunicacaoEn,
    assembleias: assembleiasEn,
    blocks: blocksEn,
    units: unitsEn,
    roles: rolesEn,
    users: usersEn,
    condominiums: condominiumsEn,
    rentals: rentalsEn,
    parking: parkingEn,
    settings: settingsEn,
    modules: modulesEn,
    company: companyEn,
    support: supportEn,
    dashboard: dashboardEn,
  },
  pt: {
    common: commonPt,
    nav: navPt,
    auth: authPt,
    residents: residentsPt,
    buildings: buildingsPt,
    maintenance: maintenancePt,
    finance: financePt,
    accessControl: accessControlPt,
    commonAreas: commonAreasPt,
    comunicacao: comunicacaoPt,
    assembleias: assembleiasPt,
    blocks: blocksPt,
    units: unitsPt,
    roles: rolesPt,
    users: usersPt,
    condominiums: condominiumsPt,
    rentals: rentalsPt,
    parking: parkingPt,
    settings: settingsPt,
    modules: modulesPt,
    company: companyPt,
    support: supportPt,
    dashboard: dashboardPt,
  },
} as const

// Português é a língua original da aplicação — fica como fallback para que
// texto ainda não migrado para outras páginas continue a aparecer, em vez de
// mostrar chaves de tradução em falta.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt',
    defaultNS,
    ns: ['common', 'nav', 'auth', 'residents', 'buildings', 'maintenance', 'finance', 'accessControl', 'commonAreas', 'comunicacao', 'assembleias', 'blocks', 'units', 'roles', 'users', 'condominiums', 'rentals', 'parking', 'settings', 'modules', 'company', 'support', 'dashboard'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'indlus:lang',
    },
  })

export default i18n
